import styled from 'styled-components';
import { TextField } from '@mui/material';

import colors from '../../../styles/colors';

const THUMB_SIZE = '72px';

const FieldBlock = styled.div`
  &:not(:last-child) {
    margin-bottom: 1.5rem;
  }
`;

const FieldLabel = styled.div`
  font-size: 0.75rem;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.06em;
  color: ${colors.shades.gamma10};
  margin-bottom: 0.375rem;
`;

const StyledTextField = styled(TextField)`
  width: 100%;

  .MuiOutlinedInput-root {
    border-radius: 8px;
    font-size: 0.875rem;
  }
`;

const HelperText = styled.div`
  margin-top: 0.75rem;
  font-size: 0.75rem;
  line-height: 1.4;
  color: ${colors.shades.gamma10};
`;

// Roughly the height of the crop frame it precedes, so the modal does not jump when it resolves.
const LoadingBlock = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 0.5rem;
  min-height: 380px;
`;

const PictureRow = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 0.5rem;
  margin-bottom: 0.75rem;
`;

// Boxes the two halves of a pair together, so it reads as the single card it becomes.
const PictureGroup = styled.div`
  padding: 0.75rem;
  border: 1px dashed ${colors.shades.secondary6};
  border-radius: 8px;
  background: ${colors.shades.secondary10};

  ${PictureRow} {
    margin-bottom: 0;
  }
`;

const PictureThumb = styled.div`
  position: relative;
  width: ${THUMB_SIZE};
  height: ${THUMB_SIZE};
  border-radius: 6px;
  overflow: hidden;
  border: 1px solid ${colors.shades.secondary7};
`;

const PictureThumbImage = styled.img`
  width: 100%;
  height: 100%;
  object-fit: cover;
  display: block;
`;

const PictureThumbRemove = styled.button`
  position: absolute;
  top: 2px;
  right: 2px;
  width: 18px;
  height: 18px;
  padding: 0;
  border: 0;
  border-radius: 50%;
  background: ${colors.addAlpha(colors.base.beta, 0.6)};
  color: ${colors.base.alpha};
  font-size: 0.75rem;
  line-height: 1;
  cursor: pointer;
`;

// Owns the height. Cropper is handed `height: 100%` and fits itself to this; given a free container
// it grows to the image's natural size and overflows.
const CropFrame = styled.div`
  width: 100%;
  height: 380px;
  background: ${colors.shades.dark1};
  border-radius: 8px;
  overflow: hidden;
`;

const CropHint = styled.div`
  margin-top: 0.75rem;
  font-size: 0.75rem;
  line-height: 1.4;
  color: ${colors.shades.gamma10};
`;

const CropWarning = styled(CropHint)`
  padding: 0.5rem 0.625rem;
  border: 1px solid ${colors.shades.warning3};
  border-radius: 6px;
  background: ${colors.shades.warning1};
  color: ${colors.shades.dark1};
  font-weight: 600;
`;

const CropActions = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  column-gap: 16px;
  margin-top: 1.25rem;
`;

export {
  LoadingBlock,
  FieldBlock,
  FieldLabel,
  StyledTextField,
  HelperText,
  PictureRow,
  PictureGroup,
  PictureThumb,
  PictureThumbImage,
  PictureThumbRemove,
  CropFrame,
  CropHint,
  CropWarning,
  CropActions,
};
